module.exports = __webpack_public_path__ + "static/media/a30.0c9d9c4b.ogg";